import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Newsletter from './icon-newsletter.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Newsletter {...validProps} />;
}
SvgComponent.iconName = 'newsletter';

export const NewsletterIcon = svgIconWrapper(SvgComponent);
